"use client";

import { SignIn, SignUp, useUser } from "@clerk/nextjs";
import { ChevronRightIcon } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Button } from "@/components/assets/button/button";
import { getIconClass } from "@/components/assets/icon/icons";

export default function LoginSwitcher() {
  const [isSignUp, setIsSignUp] = useState(false);
  const { isSignedIn } = useUser();

  useEffect(() => {
    const container = document.querySelector(".auth-container");
    if (!container) {
      return;
    }
    if (isSignUp) {
      container.classList.add("sign-up-mode");
    } else {
      container.classList.remove("sign-up-mode");
    }
  }, [isSignUp]);

  if (isSignedIn) {
    return (
      <div>
        You are signed in already! <Link href="/">Access your account</Link>
      </div>
    );
  }

  return (
    <div className="auth-container relative h-[550px] w-full max-w-[900px] overflow-hidden rounded-[20px] bg-white shadow-[0_25px_50px_rgba(0,0,0,0.2)]">
      <div className="forms-container absolute inset-0 h-full w-full">
        <div className="signin-signup">
          {/* Sign In Form */}
          <div className="auth-form sign-in-form items-enter flex flex-col justify-center px-7">
            <div className="content transition-transform delay-150 duration-900 ease-in-out">
              <h3 className="mb-2.5 text-center font-semibold text-2xl leading-none">
                Login to your account
              </h3>
              {/* <p className="text-[0.95rem] py-2.5">Get acces</p> */}
              <SignIn
                appearance={{
                  layout: {
                    socialButtonsPlacement: "bottom",
                    socialButtonsVariant: "iconButton",
                  },
                  elements: {
                    cardBox: "border-none shadow-none",
                    header: "hidden",
                    formFieldLabel: "hidden",
                    formFieldRow: "text-gray-700",
                    formFieldHelperText: "text-gray-700",
                    formFieldInput:
                      "outline-custom-blue-dark rounded-full px-4 py-3 focus:outline-3 text-gray-700",
                    footer: "hidden",
                    formButtonPrimary:
                      "bg-custom-blue-dark hover:bg-custom-blue text-lg rounded-full",
                  },
                }}
                routing="hash"
              />
            </div>
          </div>
          {/* Sign Up Form */}
          <div className="auth-form sign-up-form flex flex-col items-center justify-center px-20">
            <h3 className="mb-2.5 text-center font-semibold text-2xl leading-none">
              Create your account
            </h3>
            <SignUp
              appearance={{
                layout: {
                  socialButtonsPlacement: "bottom",
                  socialButtonsVariant: "blockButton",
                },
                elements: {
                  cardBox: "border-none shadow-none",
                  header: "hidden",
                  formFieldLabel: "hidden",
                  footer: "hidden",
                  formFieldInput:
                    "outline-custom-yellow-dark rounded-full px-4 py-3 focus:outline-3 text-gray-700",
                  formButtonPrimary:
                    "bg-custom-yellow hover:bg-custom-yellow/80 text-lg text-custom-blue-dark border-none outline-none rounded-full",
                },
              }}
              routing="hash"
            />
          </div>
        </div>
      </div>

      <div className="panels-container absolute inset-0 grid h-full w-full grid-cols-2">
        <div className="panel pointer-events-auto left-panel z-6 flex flex-col items-end justify-around py-12 pr-[17%] pl-[12%] text-center">
          <div className="content items-center justify-center text-center text-white transition-transform delay-150 duration-900 ease-in-out">
            <h3 className="mb-2.5 text-center font-semibold text-2xl leading-none">
              Not yet a Teletradie?
            </h3>
            <p className="pb-3.5 text-center font-medium">
              Get your jobs rolling with your instant free account today. No
              credit card required.
            </p>
            <Button
              className="mx-auto"
              color="secondary"
              iconAfter={<ChevronRightIcon />}
              onClick={() => setIsSignUp(true)}
              shimmer
              size="lg"
            >
              Lets get started
            </Button>
            {/* <button
              type="button"
              className="rounded-full auth-btn transparent m-0 bg-transparent border-2 border-white w-[130px] h-[41px] font-semibold text-[0.8rem] hover:bg-white/10 hover:-translate-y-0.5 transition-all"
              onClick={() => setIsSignUp(true)}
            >
              Lets get started
            </button> */}
          </div>
        </div>

        <div className="panel pointer-events-none right-panel z-6 flex flex-col items-end justify-around py-12 pr-[12%] pl-[17%] text-center">
          <div className="content text-white transition-transform delay-150 duration-900 ease-in-out">
            <h3 className="mb-2.5 font-semibold text-2xl leading-none">
              Already a Teletradie?
            </h3>
            <p className="pb-3.5 font-medium">Welcome back!</p>
            <Button
              className="mx-auto"
              color="secondary"
              iconBefore={
                <span className={`${getIconClass("login", "xl")}text-white`} />
              }
              onClick={() => setIsSignUp(false)}
              shimmer
              size="lg"
            >
              Login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
